<template functional>
  <div>
    <a
      href="#"
      @click="$options.show(props)"
      :class="{ Rojo: props.row.ToTal_ClientPayment < 0 }"
      >{{ $options.formatMonto(props.row.ToTal_ClientPayment) }}</a
    >
  </div>
</template>

<script>
//import store from "../../../../store/index";
import { formatMonto } from "@/utils";
export default {
  formatMonto,
  name: "HyperlinkPagoProveedores",
  isRed: false,
  show(ops) {
    ops;
    ops.row.OpenClientPagoProveedoresReport(ops.row);
    /*
      store.dispatch("getAllCustomer", {
        empresaid: ops.row.Empresaid
      });
      */
  },
  hyperlinkWithFormat(e, props) {
    const value = props.row.ToTal_ClientPayment;
    if (parseFloat(value) < 0) {
      this.isRed = true;
    } else {
      this.isRed = false;
    }
    return value;
  }
};
</script>
